import { render, staticRenderFns } from "./PreVote.vue?vue&type=template&id=c616829c&"
import script from "./PreVote.vue?vue&type=script&lang=js&"
export * from "./PreVote.vue?vue&type=script&lang=js&"
import style0 from "./PreVote.vue?vue&type=style&index=0&id=c616829c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports